module.exports = __webpack_public_path__ + "static/media/menu-qrcode.5c4169ac.svg";